import {
  Box,
  Heading,
} from "@radix-ui/themes";
import { Application, Participant } from "@/types/shared";
import ProfileApplicationsTable from "@/shared/tables/ProfileApplicationsTable";
import UserPageShell from "@/shared/users/UserPageShell";

interface User {
  id: number;
  email: string;
}

interface DriverCar {
  id: number;
  display_name: string;
  driver_name: string;
  make: string;
  model: string;
  year: number | null;
  participant: {
    id: number;
    name: string;
  } | null;
}

interface ProfileProps {
  user: User;
  participants: Participant[];
  applications: Application[];
  driver_cars: DriverCar[];
  has_staff_participant: boolean;
  has_media_group_participant: boolean;
}

export default function Profile({ applications }: ProfileProps) {
  return (
    <UserPageShell title="Applications">
      <section>
        <Heading mb="4">Applications</Heading>
        <Box style={{ overflowX: "auto" }}>
          {applications.length > 0 ? (
            <ProfileApplicationsTable applications={applications} />
          ) : (
            <p>No applications found.</p>
          )}
        </Box>
      </section>
    </UserPageShell>
  );
}
